import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Appearance, Button, Icon, Text } from "@blasterjs/core";
import { Case } from "../models";
import TopBar from "./TopBar";
import { useAppSelector } from "../hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import KeyboardShortcutDialog from "./KeyboardShortcutDialog";

interface Props {
  readonly histoCase: Case;
  readonly isCR: boolean;
}

const TopBarCase = ({ histoCase, isCR }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const embedded = useAppSelector(state => state.config.embedded);

  const close = (histoCase: Case) => () => {
    const from = location.state?.from;
    const knownRoutes = [
      "/image-management/annotations",
      "/image-management/cases",
      "/queries/cases"
    ];

    if (knownRoutes.includes(from)) {
      navigate(from);
    } else {
      navigate(`/studies/${histoCase.studyId}/cases`);
    }
  };

  const closeButton =
    embedded && isCR ? (
      <Text>&nbsp; </Text>
    ) : (
      <Button appearance={Appearance.MINIMAL} color="#fff" onClick={close(histoCase)}>
        <Icon name="close" />
      </Button>
    );

  const [isKeyboardShortcutDialogOpen, setKeyboardShortcutDialogOpen] = useState<boolean>(false);
  const keyboardShortcutButton = (
    <>
      <Button
        className="transparent-keyboard-shortcut-button"
        style={{ marginLeft: "auto", marginRight: "1rem" }}
        onClick={() => setKeyboardShortcutDialogOpen(true)}
      >
        <FontAwesomeIcon
          icon={faQuestionCircle}
          size="2x"
          style={{ color: "#C3C3C3", transform: "scale(0.75)" }}
        />
      </Button>
    </>
  );

  return (
    <TopBar>
      {closeButton}
      {histoCase.procId}
      {keyboardShortcutButton}
      <KeyboardShortcutDialog
        isOpen={isKeyboardShortcutDialogOpen}
        setOpenDialog={setKeyboardShortcutDialogOpen}
      />
    </TopBar>
  );
};

export default TopBarCase;
